import React, {Component} from 'react'
import { BrowserRouter as Router, Route } from "react-router-dom";

import EstateContainer from './components/container/containerComponent'
import EstateComponent from './components/estate/estateComponent'

class Routes extends Component {

    render(){

        return (
            <Router>
                <Route path="/" exact component={EstateContainer} />
                <Route path="/estate/:id" component={EstateComponent} />
            </Router>
        )
    }
}

export default Routes;
